export class LoanBankAccount {
    constructor(
        id,
        bank,
        clabe,
        stpCode,
        verified,
        verifiedDate,
    ) {
        this.id = id;
        this.bank = bank;
        this.clabe = clabe;
        this.stpCode = stpCode;
        this.verified = verified;
        this.verifiedDate = verifiedDate;
    }
}